<div class="w-full h-full">
  <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
    <div class="reports-container p-6">
      <div class="mb-6">
        <h1 class="text-3xl mb-4 underline">Reports</h1>
        <p class="text-2xl text-gray-800 dark:text-gray-200 mb-2">
          Design: {{ designName() }}
        </p>
      </div>

  <div class="reports-grid grid grid-cols-1 lg:grid-cols-3 gap-6">
    <section class="report-column" *ngFor="let group of reportGroups()">
      <fieldset class="report-group-fieldset">
        <legend class="text-lg font-semibold report-group-title">
          <span class="peri-txt">PERI</span><span [style.color]="group.labelColor">{{ group.suffixLabel }}</span><span> {{ group.trailingLabel }}</span>
        </legend>
        <div class="flex flex-col gap-4">
        <p-card *ngFor="let report of group.reports" class="report-card">
          <ng-template pTemplate="header">
            <div class="flex items-center gap-2 p-4 pb-0">
              <i class="pi pi-file-word text-2xl text-primary"></i>
              <h3 class="text-l">{{ report.name }}</h3>
              <p
                 class="px-4 text-sm whitespace-nowrap ml-auto"
                [style.color]="getSetupStatusLabel(report) === 'Not configured' ? '#dc2626' : '#16a34a'"
              >
                {{ getSetupStatusLabel(report) }}
              </p>
            </div>
          </ng-template>
          <ng-template pTemplate="footer">
            <div class="flex justify-end gap-2 p-3">
              @if (canConfigureReport(report)) {
                <p-button
                  label="Setup"
                  icon="pi pi-cog"
                  class="outlined-button"
                  severity="secondary"
                  outlined="true"
                  size="small"
                  [loading]="report.isSetupLoading"
                  [disabled]="report.isSetupLoading"
                  (onClick)="setupReport(report)"
                ></p-button>
              }
              <p-button
                label="Download"
                icon="pi pi-download"
                class="outlined-button"
                severity="success"
                outlined="true"
                size="small"
                [loading]="report.isLoading"
                (onClick)="downloadReport(report)"
              ></p-button>
            </div>
          </ng-template>
        </p-card>
        </div>
      </fieldset>
    </section>
  </div>

      @if (!hasDesign()) {
      <div class="mt-6">
        <p-message severity="warn" text="No design selected. Please select a design to generate reports."></p-message>
      </div>
      }
    </div>
  </p-scrollPanel>
</div>
